import React, { useState, useEffect } from 'react';
import {
  delegateConfirm,
  setExecutorSchedule,
  setIsSendingDelegate,
  setProvideTo,
} from '../actions';
import { connect } from 'react-redux';
import { User, Item, Schedule, Task } from '../../../common/types';
import { State } from '../../../rootReducer';
import { fetchData } from '../../../utils/fetchData';
import MultySelect from '../../../common/components/Selects/MultySelect';
import styled from 'styled-components';
import Button from '../../../common/components/newComponent/Buttons/Button';
import {timeZone} from "../../../common/format";

type Props = {
  users: User[];
  executor_id: number | null;
  delegatedId: number | null;
  selectedUserId: number;
  provide_to: number;
  setExecutorSchedule: (schedule: Schedule) => void;
  setProvideTo: (val: number) => void;
  selectedItems: Item[];
  setSelectedItems: (arg: Item[]) => void;
  currentUserRoles: number[] | undefined;
  selectedTask: Task | null;
  setIsSendingDelegate: (isSending: boolean) => void;
  isSendingDelegate: boolean;
  delegateConfirm: (users_ids: number[]) => void;
};

const WrapperExecuterWithDelegate = styled.div``;

const WrapperConfirmButton = styled.div``;

const ExecutorSelect: React.FC<Props> = ({
  selectedUserId,
  users,
  executor_id,
  delegatedId,
  setExecutorSchedule,
  setProvideTo,
  provide_to,
  selectedItems,
  setSelectedItems,
  currentUserRoles,
  selectedTask,
  delegateConfirm,
  setIsSendingDelegate,
  isSendingDelegate,
}) => {
  const [usersIdList, setUsersIdList] = useState([]); // айдишники пользователей, доступных в этом проекте
  const [executorData, setExecutorData] = useState(
    // выпадающий список
    {
      selected: null as Item | null,
      list: [] as Item[],
      delegatedTo: null as Item | null,
    }
  );

  useEffect(() => {
    (async () => {
      if (!selectedTask?.project_id) return;
      let usersIdForProject = await fetchData.get(
        `/api/v1/projects/${selectedTask?.project_id}/users`
      );

      // в старых проектах данные хранились в виде объекта, а не массива. Для гарантии конвертирую в массив.
      usersIdForProject = Object.values(usersIdForProject);
      setUsersIdList(usersIdForProject);

      // получили юзеров по этому проекту. Если в этом массиве айдишников есть тот юзер, который сейчас стоит исполнителем - по которому открыты задачи, то его и оставляем. Если нет - значит просто стереть.
      let found;
      usersIdForProject.forEach((id) => {
        if (id === selectedUserId) found = true;
      });

      if (!found) {
        setExecutorData({
          selected: null,
          list: executorData.list,
          delegatedTo: executorData.delegatedTo,
        });
      }
    })();
  }, [selectedTask?.project_id]);

  useEffect(() => {
    (async () => {
      if (!executor_id) return;
      let time_Zone = timeZone();
      const data = await fetchData.get(`/api/v1/users/${executor_id}/schedule?tz=${time_Zone}`);
      setExecutorSchedule(data?.schedule);
    })();
  }, [executor_id]);

  useEffect(() => {
    let selected = executorData.selected,
      delegatedTo = executorData.delegatedTo,
      list: Item[] = [];

    // здесь формируется выпадающий список
    usersIdList.forEach((userId) => {
      // users - это commonUsers
      // достаю полную информацию о пользователе из commonInfo, имея только айдишники пользователей, доступных в этом проекте
      let user = users.find((user) => user.id === userId);
      if (user) {
        let item = {
          text: `${user.surname} ${user.name}`,
          value: user.id,
          urlImage: user.image?.url,
        };
      
        list.push(item);
      }
    });
    setExecutorData({ selected, list, delegatedTo });
  }, [delegatedId, executor_id, users, usersIdList]);

  return (
    <WrapperExecuterWithDelegate>
      {/*исполнителю вообще не должна показываться эта галка*/}

      <MultySelect
        radio={!!selectedTask}
        disabled={usersIdList.length === 0 || isSendingDelegate}
        itemsList={executorData.list}
        selectedItems={selectedItems}
        addHandler={(arg) => {
          setSelectedItems([
            ...selectedItems,
            executorData.list.find((item) => item.value === arg) as Item,
          ]);
        }}
        removeHandler={(arg) => {
          let coped_array = selectedItems.map((each) => ({
            value: each.value,
            text: each.text,
          }));
          coped_array.splice(
            coped_array.findIndex((item) => item.value === arg),
            1
          );
          setSelectedItems(coped_array); // соответственно удаляется
        }}
      />

      {Boolean(selectedTask?.provide_to) && Boolean(selectedItems.length) && (
        <WrapperConfirmButton>
          <Button
            title={'Делегировать'}
            isSending={isSendingDelegate}
            onClick={() => {
              if (!isSendingDelegate) {
                setIsSendingDelegate(true);
                let users_ids = selectedItems.map((item) => item.value);
                delegateConfirm(users_ids as number[]);
              }
            }}
          />
        </WrapperConfirmButton>
      )}
    </WrapperExecuterWithDelegate>
  );
};

const mapStateToProps = (state: State) => {
  return {
    selectedTask: state.taskInfoPlate.selectedTask,
    isSendingDelegate: state.taskInfoPlate.isSendingDelegate,
    currentUserRoles: state.commonInfo.currentUserInfo?.roles,
    provide_to: state.taskInfoPlate.provide_to,
    selectedUserId: state.tasksPage.selectedUserId,
    executor_id: state.taskInfoPlate.executor_id,
    users: state.commonInfo.users,
    delegatedId: state.newTask.delegatedTo,
  };
};

const mapDispatchToProps = {
  setExecutorSchedule,
  delegateConfirm,
  setProvideTo,
  setIsSendingDelegate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExecutorSelect);
